<template>
  <a-form-model ref="loginForm" layout="vertical" :model="form" :rules="rules">
    <a-form-model-item prop="phone" >
      <a-input v-model="form.phone" :placeholder="$t('message.nameErr')" @pressEnter="onSubmit">
        <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
      </a-input>
    </a-form-model-item>
    <a-form-model-item prop="password" >
      <a-input v-model="form.password" type="password" :placeholder="$t('login.password')" @pressEnter="onSubmit">
        <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
      </a-input>
    </a-form-model-item>
    <a-form-model-item>
      <a-button
        block
        type="primary"
        class="ant-btn-lg"
        @click="onSubmit"
      >{{this.$t('login.login')}}</a-button>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { login } from "@/api/user.js";
import { isMobile } from "@/utils/tools.js";

export default {
  data() {
    return {
      form: { phone: "", password: "" },
      loadingKey: "loginLoadingKey",
      rules: {
        phone: [
          {
            required: true,
            message: this.$t("message.nameErr"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("login.password"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  created() {
    // document.
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.loginForm.resetFields();
    });
  },
  methods: {
    toRegister() {
      this.$emit("toRegister");
    },
    onSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$message.loading({
            content: this.$t('message.waitting')+"...",
            key: this.loadingKey,
          });
          this.$store
            .dispatch("login", this.form)
            .then((res) => {
              // this.$message.success(this.$t("message.loginSuccess"), 1);
              this.$message.success({
                content: this.$t("message.loginSuccess"),
                key: this.loadingKey,
                duration: 1,
              });
              if (isMobile()) {
                this.$router.push({ path: "/mobile/member/mine" });
              } else {
                let userType = res.user.type;
                if (userType == 1) {
                  this.$router.push({ path: "/admin/home" });
                } else if (userType == 2) {
                  this.$router.push({ path: "/agent/home" });
                }else if(userType==3){
                  this.$router.push({ path: "/member/home" });
                } else {
                  this.$router.push({ path: "/employee/home" });
                }
              }
              this.$emit("loginSuccess");
            })
            .catch((err) => {
              console.log("====error===", err);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.options {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  height: 50px;
}

@media screen and (min-width: 768px) {
  .title {
    line-height: 6;
    text-align: center;
  }
  .content {
    width: 400px;
    margin: 60px auto 0;
    padding: 50px 50px 30px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
    vertical-align: middle;
  }
}

@media screen and (max-width: 768px) {
  .title {
    line-height: 6;
    text-align: center;
  }
  .content {
    width: 100%;
    margin: 0 auto 0;
    padding: 50px 50px 30px;
    box-shadow: none;
  }
}
</style>